const videoPlayers = document.querySelectorAll(`.js--video`);

const getVideoUrl = (rawValue) => {
  if (!rawValue) {
    return ``;
  }

  try {
    const parsed = JSON.parse(rawValue);

    return parsed?.url ?? rawValue;
  } catch (error) {
    return rawValue;
  }
};

const getVideoDetails = (rawValue) => {
  const videoUrl = getVideoUrl(rawValue).trim();

  if (!videoUrl) {
    return null;
  }

  if (/^\d+$/.test(videoUrl)) {
    return {
      provider: `vimeo`,
      id: videoUrl,
      embedUrl: `https://player.vimeo.com/video/${videoUrl}?autoplay=1&autopause=0`,
      thumbnailUrl: `https://vumbnail.com/${videoUrl}_large.jpg`,
    };
  }

  let url;

  try {
    const normalizedUrl = /^[a-z][a-z\d+\-.]*:\/\//i.test(videoUrl)
      ? videoUrl
      : `https://${videoUrl}`;

    url = new URL(normalizedUrl);
  } catch (error) {
    return null;
  }

  const hostname = url.hostname.replace(/^www\./, ``);

  if (hostname === `youtu.be`) {
    const id = url.pathname.split(`/`).filter(Boolean)[0];

    return id
      ? {
          provider: `youtube`,
          id,
          embedUrl: `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`,
          thumbnailUrl: `https://i.ytimg.com/vi/${id}/hqdefault.jpg`,
        }
      : null;
  }

  if (hostname === `youtube.com` || hostname === `m.youtube.com` || hostname === `youtube-nocookie.com`) {
    const pathParts = url.pathname.split(`/`).filter(Boolean);
    const id = url.searchParams.get(`v`) ?? pathParts.find((part, index) => [`embed`, `shorts`, `live`].includes(pathParts[index - 1]));

    return id
      ? {
          provider: `youtube`,
          id,
          embedUrl: `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`,
          thumbnailUrl: `https://i.ytimg.com/vi/${id}/hqdefault.jpg`,
        }
      : null;
  }

  if (hostname === `vimeo.com` || hostname === `player.vimeo.com`) {
    const id = url.pathname.split(`/`).filter((part) => /^\d+$/.test(part)).pop();

    return id
      ? {
          provider: `vimeo`,
          id,
          embedUrl: `https://player.vimeo.com/video/${id}?autoplay=1&autopause=0`,
          thumbnailUrl: `https://vumbnail.com/${id}_large.jpg`,
        }
      : null;
  }

  return null;
};

videoPlayers.forEach(player => {
  const video = getVideoDetails(player.dataset.videoUrl ?? player.dataset.id);
  const playButton = player.querySelector(`.js--video__button`);
  const contentWrapper = player.querySelector(`.js--video__wrapper`);
  const thumbnail = player.querySelector(`.js--video__thumbnail`);

  if (!video || !playButton || !contentWrapper) {
    return;
  }

  if (thumbnail) {
    thumbnail.src = video.thumbnailUrl;
  }

  const templateIframe = document.createElement(`iframe`);
  templateIframe.setAttribute(`allow`, `accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen`);
  templateIframe.setAttribute(`allowfullscreen`,``);
  templateIframe.setAttribute(`referrerpolicy`, `strict-origin-when-cross-origin`);
  templateIframe.setAttribute(`title`, `${video.provider} video player`);

  playButton.addEventListener(`click`,function(){
    if (contentWrapper.querySelector(`iframe`)) {
      return;
    }

    const iframe = templateIframe.cloneNode();
    iframe.src = video.embedUrl;
    contentWrapper.append(iframe);
  });
});
